import _ from 'lodash';
import { IArrival, IAnnounce, ISharingForecast } from '@/appLogic/interfaces/forecast';
import { IForecast } from '@/appLogic/interfaces/forecast';

import { IDrawingBusiness } from '@/appLogic/interfaces/misc';
import { FORECAST_INITIAL_VALUE, FORECAST_LENGTH } from '@/coreDomainsModule/constants';
import { IDealing } from '../interfaces/dealing';
import { ICommunicationMessage } from '../interfaces/message';
import { IItem } from '../interfaces/item';
import { TranslateKeyName, OutputFileType } from '../../coreDomainsModule/translateExcel';
import { IOrder } from '../interfaces/order';
import { simpleCopy } from '@/utils/deepCopy';
import { IBusiness, IBusiness as newIBusiness } from '@/coreDomainsModule/entities/businessBase';
import { BusinessFactory } from '@/coreDomainsModule/factories/BusinessFactory';
export const initialAnnounce: IAnnounce = {
  amount: FORECAST_INITIAL_VALUE,
  year: 0,
  month: 0,
};

export const initialArrival: IArrival = {
  year: 0,
  month: 0,
  day: 0,
  amount: 0,
  leadTime: -1,
};

export const initialForecast: IForecast = {
  businessId: '',
  customerAnnounce: new Array(FORECAST_LENGTH).fill({ ...initialAnnounce }),
  arrival: [],
  recommend: [],
};

/**
 * 在庫情報の初期化
 */
export const initialOrder: IOrder = {
  orderAmount: -1, // 発注数量(mvpでは使っていない)
  orderDate: '2021-4-1', // 発注日(mvpでは使っていない)
  deliveryDate: undefined, // 納入日(mvpでは使っていない) (希望納期)
  isFixOrdered: false, // 確定発注かどうか
  defineOrderNumber: undefined, // 確定発注展開時に、ユニークに判定するために
  maxInventoryIndex: undefined, //　(mvpでは使っていない)
  fixOrderDate: undefined, // 確定発注日(推奨発注日?)
};

export const defaultAnnounce: IAnnounce[] = new Array(FORECAST_LENGTH).fill({ ...initialAnnounce });

export const newDefaultData: newIBusiness = BusinessFactory.create();

// 自社商品の初期化用
export const initialItem: IItem = {
  itemName: '', // 商品名
  itemNumber: '', // 商品の品番
  note: '', // 備考
  endOfProduction: undefined, // 生産終了日
};

// 取引の初期化用
// export const defaultBusinessData: IBusiness = {
//   targetItemId: '',
//   salesStatus: 'unsupported', // 取引のステータス
//   // supportTable: {  // TODO: インタフェース定義の見直し
//   //   supplierOrganizationId: '', // 売り手のorgID
//   //   sellerBusinessId: '', // 売り手の商品のID
//   //   customerOrganizationId: '', // 買い手のorgID
//   //   buyerBusinessId: '', //　買い手の商品のID
//   // }, // 品番対応表,必須にしておく
//   businessName: '', //　商品名
//   package: '', // 容量
//   unit: '', // 単位
//   deliveryDestinationName: '', // 納入先
//   manufacture: '', // 製造社
// };

// 共通取引の初期化用
export const defaultShareBusinessData: IDealing = {
  sellerId: '',
  dataId: '',
  buyerId: '',
  senderId: '', // 送り主のID
  dataType: '',
  shareBusinessId: '', // 取引ID
  updatedAt: -1,
  removeAt: -1,
  deleted: false,
  salesStatus: 'cooperationRequest', // 取引のステータス
  supportTable: {
    // TODO: インタフェース定義の見直し
    sellerBusinessId: '', // 売り手の商品のID
    buyerBusinessId: '', //　買い手の商品のID
  }, // 品番対応表,必須にしておく
  businessName: '', //　商品名
  package: '', // 容量
  unit: '', // 単位
  deliveryDestinationName: '', // 納入先
  manufacture: '', // 製造社
  comment: '',
};

// やり取りするメッセージの初期化
export const defaultMessageData: ICommunicationMessage = {
  sellerId: '',
  dataId: '',
  buyerId: '',
  senderId: '', // 送り主のID
  dataType: '',
  shareBusinessId: '', // 取引ID
  updatedAt: -1,
  removeAt: -1,
  deleted: false,
  sequenceNumber: 0,
  message: '',
};

// 入力エクセルファイルを保持するオブジェクトの初期化
export const defaultInputFileInfo: { [key in TranslateKeyName | OutputFileType]: File | undefined } = {
  在庫表: undefined,
  仕入先内示: undefined,
  内示: undefined,
  日別内示: undefined,
  販売実績: undefined,
  入荷: undefined,
  在庫: undefined,
  発注取込: undefined,
};

// どのエクセルファイルが入力されているかを保持するオブジェクトの初期化
export const defaultImportFlags: { [key in TranslateKeyName | OutputFileType]: boolean } = {
  在庫表: false,
  仕入先内示: false,
  内示: false,
  日別内示: false,
  販売実績: false,
  入荷: false,
  在庫: false,
  発注取込: false,
};

// xlsxFormFilesの初期化
export const defaultXlsxFormFileInfo: { [key in TranslateKeyName | OutputFileType]: any } = {
  内示: undefined,
  日別内示: undefined,
  販売実績: undefined,
  入荷: undefined,
  在庫: undefined,
  在庫表: undefined,
  仕入先内示: undefined,
  発注取込: undefined,
};

// 共通内示の初期化用
export const defaultShareForecastData: ISharingForecast = {
  senderId: '',
  sellerId: '',
  dataId: '',
  buyerId: '',
  dataType: '',
  shareBusinessId: '', // 取引ID
  updatedAt: -1,
  removeAt: -1,
  deleted: false,
  customerAnnounce: [] as IAnnounce[], // 初期値はsetAnnounceYearMonthによってセットする
};

// 取引情報の絵のラベル
export const drawingLabelData: IDrawingBusiness = {
  supplierName: '仕入先',
  businessName: '商品',
  package: '容量',
  unit: '単位',
  deliveryDestinationName: '売上先',
  manufacture: '製造社',
  warehouse: '倉庫',
  endUser: 'エンドユーザー',
  subcontractor: '外注先',
  secondSubcontractor: '外注先の外注先',
};

// どの対応表を用いるかを判定するためのもの
// TODO: 代入対応表を追加したら、ここも追加すること
type typeOfSetIBusiness =
  | 'setSendCooperationRequest'
  | 'setAddItem'
  | 'setBuyerBusinessForBuySell'
  | 'setSellerBusinessForBuySell'
  | 'setAddBusinessForReadExcel'
  | 'setCreateBusiness'
  | 'setAddItemForReadExcel'
  | 'setBusinessEdit'
  | 'setReceivedDealings';
// TODO: まだ取引、商品に関する明確な法則等が定義されていないので、暫定的に
// 命名は基本的には　set + 使用される関数名（どれか１つ、もし重複している場合は共通化を適宜実施）

const setSendCooperationRequest: Record<string, string> = {
  deliveryDestinationName: 'deliveryDestinationName',
  manufacture: 'manufacture',
  package: 'package',
  businessName: 'businessName',
  unit: 'unit',
  endUser: 'endUser',
};

const setAddItem: Record<string, string> = {
  businessName: 'itemName',
  package: 'package',
  unit: 'unit',
  deliveryDestinationName: 'deliveryDestinationName',
  manufacture: 'manufacture',
  warehouse: 'warehouse',
  endUser: 'endUser',
  note: 'note',
  leadTime: 'leadTime',
  MOQ: 'MOQ',
};

const setCreateBusiness: Record<string, string> = {
  businessName: 'businessName',
  unit: 'unit',
  package: 'package',
  note: 'note',
};

const setBuyerBusinessForBuySell: Record<string, string> = {
  deliveryDestinationName: 'warehouse',
  endUser: 'customerName',
  note: 'note',
  leadTime: 'leadTime',
  MOQ: 'MOQ',
  stdInventoryIndices: 'stdInventoryIndices',
};

const setSellerBusinessForBuySell: Record<string, string> = {
  endUser: 'endUser',
  note: 'note',
  leadTime: 'leadTime',
  MOQ: 'MOQ',
  stdInventoryIndices: 'stdInventoryIndices',
};

const setAddBusinessForReadExcel: Record<string, string> = {
  businessName: 'businessName',
  package: 'package',
  salesDestinationName: 'salesDestinationName',
  supplierName: 'supplierName',
  customerName: 'customerName',
  note: 'note',
  unit: 'unit',
  deliveryDestinationName: 'deliveryDestinationName',
  manufacture: 'manufacture',
  warehouse: 'warehouse',
  endUser: 'endUser',
  secondSubcontractor: 'secondSubcontractor',
  MOQ: 'MOQ',
  arrivals: 'arrivals',
  form: 'form',
  inventory: 'inventory',
  leadTime: 'leadTime',
  minusInventory: 'minusInventory',
  salesResults: 'salesResults',
  salesPosition: 'salesPosition',
  sellInventory: 'sellInventory',
  stdInventoryIndex: 'stdInventoryIndex',
  stdInventoryIndices: 'stdInventoryIndices',
  subcontractor: 'subcontractor',
};

const setAddItemForReadExcel: Record<string, string> = {
  businessName: 'businessName',
  package: 'package',
  salesDestinationName: 'salesDestinationName',
  supplierName: 'supplierName',
  customerName: 'customerName',
  note: 'note',
  unit: 'unit',
  deliveryDestinationName: 'deliveryDestinationName',
  manufacture: 'manufacture',
  warehouse: 'warehouse',
  endUser: 'endUser',
  arrivals: 'arrivals',
  salesResults: 'salesResults',
  inventory: 'inventory',
  secondSubcontractor: 'secondSubcontractor',
};

const setBusinessEdit: Record<string, string> = {
  endUser: 'businessName',
  supplierName: 'package',
  deliveryDestinationName: 'salesDestinationName',
  businessName: 'supplierName',
  note: 'customerName',
  unit: 'note',
  form: 'unit',
  customerName: 'deliveryDestinationName',
  warehouse: 'manufacture',
  manufacture: 'warehouse',
};

const setReceivedDealings: Record<string, string> = {
  businessName: 'businessName',
  package: 'package',
  unit: 'unit',
  deliveryDestinationName: 'deliveryDestinationName',
  manufacture: 'manufacture',
  endUser: 'endUser', // TODO: エンドユーザーをsharBusinessで管理すべきでは？
  businessId: 'shareBusinessId', // 受信テーブルでのBusinessIdは共通取引のIDとして扱う
  linkedShareBuzId: 'senderId',
};

/**
 *
 */
export const getOldInitialData = (): IBusiness => simpleCopy(newDefaultData);
/**
 *
 */
export const getInitialData = (): newIBusiness => simpleCopy(newDefaultData);
export { typeOfSetIBusiness };
